import type { ReactElement } from 'react'
import { createFileRoute, notFound, useRouter } from '@tanstack/react-router'
import { withSessionRedirect } from '../lib/require-session.ts'
import { RegistryPage } from '../components/RegistryPage.tsx'
import { isRegistryKind, listRegistry } from '../lib/registry-api.ts'

export const Route = createFileRoute('/registry/$kind')({
  loader: async ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router's documented notFound() pattern throws a NotFoundError object
    if (!isRegistryKind(params.kind)) throw notFound()
    const kind = params.kind
    return await withSessionRedirect(async () => {
      const rows = await listRegistry(kind)
      return { kind, rows }
    })
  },
  component: RegistryRoute,
})

/**
 * The route is now nothing but the loader and the page.
 *
 * The seven-kind switcher that used to live here as a grey `bg-gray-50`
 * strip moved into `RegistryKindNav`, which `RegistryPage` renders in its
 * `PageHeader` breadcrumb slot — the kinds are a dimension of that page,
 * not a second navigation bar above it.
 */
function RegistryRoute(): ReactElement {
  const { kind, rows } = Route.useLoaderData()
  const router = useRouter()

  return (
    <RegistryPage
      kind={kind}
      rows={rows}
      onChanged={async () => {
        await router.invalidate()
      }}
    />
  )
}
